var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"container",attrs:{"shadow":"always"}},[_c('el-switch',{on:{"change":_vm.switchChange},model:{value:(_vm.maxOrAdd),callback:function ($$v) {_vm.maxOrAdd=$$v},expression:"maxOrAdd"}}),_c('div',{staticClass:"chart",attrs:{"id":"lineChart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }